import { ConnectiveNode, VariableNode } from 'sma.admin/components/filters/nodes';

class Filter {
	get defaults () {
		return {
			container: $('<div></div>', { class: 'filters-ui-container' })
		};
	}

	constructor (config, filtersInfo) {
		this.filterInfo = null;
		this.idMap = null;
		this.root = null;
		this.handleChanges = null;

		if (config.container !== undefined) {
			config.container.addClass('filters-ui-container');
		}
		if (config.handleChanges !== undefined) {
			this.handleChanges = config.handleChanges;
		}

		this.options = $.extend({}, this.defaults, config);

		this.buildElement();
		if (filtersInfo !== undefined) {
			this.loadFilterInfo(filtersInfo);
		}
	}

	buildFilters () {
		if (this.filterInfo === null) {
			return;
		}

		this.idMap = {};
		this.sourceDropdown = $('<select></select>');

		$('<option></option>', {
			value: '',
			text: gettext('Select a filter...')
		}).appendTo(this.sourceDropdown);

		for (let group in this.filterInfo) {
			let groupFilters = this.filterInfo[group];

			let optgroup = $('<optgroup></optgroup>', {
				label: group
			});

			for (let option of groupFilters.data) {
				let value = '';
				let text;
				let disabled;

				if ('id' in option) {
					this.idMap[option.id] = option;
					value = option.id;
					text = option.label;
					disabled = false;
				} else {
					text = option.text;
					disabled = true;
				}

				optgroup.append(
					$('<option></option>', {
						value: value,
						text: text,
						disabled: disabled
					})
				);
			}

			this.sourceDropdown.append(optgroup);
		}
	}

	isEmpty() {
		return this.root === null || (this.root.children.length == 1 && this.root.children[0].variable == null);
	}

	clearFilters() {
		if (this.root !== null) {
			this.root.element.empty();
			this.root = null;
		}

		this.root = new ConnectiveNode(this, {type: 'AND', isRoot: true});
		this.root.newNode();

		this.element.append(this.root.element);
		this.element.children('.connective-node').removeClass('nested');
	}

	loadFilterInfo(info) {
		this.filterInfo = info.filters;
		this.buildFilters();

		this.changeFilters(info.current_filters);
		this.element.children('.connective-node').removeClass('nested');

		if (this.root === null) {
			this.clearFilters();
		}
	}

	changeFilters(firstNode) {
		this.element.empty();
		this.root = this.parse(firstNode, true);
	}

	parse(info, firstNode) {
		const type = info.type || '';

		if (['AND', 'OR'].indexOf(type.toUpperCase()) > -1) {
			const node = new ConnectiveNode(this, {type: type.toUpperCase(), isRoot: firstNode});

			if (info.items !== undefined) {
				node.negated = info.negated || false;

				for (let i = 0; i < info.items.length; i++) {
					const item = this.parse(info.items[i], false);

					if (item !== null) {
						node.addNode(item);
					}
				}
			}

			if (node.children.length === 0) {
				return null;
			}

			this.element.append(node.element);
			return node;
		} else if (info.hasOwnProperty('variable')) {
			return new VariableNode(
				this,
				this.idMap[info.variable],
				{
					predicate: info.predicate,
					variable: info.variable,
					value: info.value
				}
			);
		}

		return null;
	}

	buildElement() {
		this.element = this.options.container;
	}

	_stringify(obj, isRoot) {
		let result = '';
		if (obj.children.length > 0) {
			for (let i = 0; i < obj.children.length; i++) {
				const child = obj.children[i];
				if ($.type(child) === 'string') {
					result += '<div class="description">' + child + '</div>';
				} else {
					result += '<div class="nested">' + this._stringify(child, false) + '</div>';
					if (isRoot) {
						result += '<hr>';
					}
				}
				if (i < obj.children.length-1) {
					result += '<div class="connector">' + obj.connector + '</div>';
				}
			}
		}

		return result;
	}

	stringify() {
		if (this.root === null) {
			return '';
		}

		let htmlOutput = '<div class="filter-info">';
		const logicObj = this.root.stringify();

		htmlOutput += this._stringify(logicObj, true);
		htmlOutput += '</div>';

		return htmlOutput;
	}

	serialize() {
		const result = this.root.serialize();
		return result;
	}
}

module.exports = Filter;
